<template>
  <b-modal ref="modal-stethoscope" v-model="showModal" @close="close" size="lg">
    <div class="row">
      <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
        <img class="center-block subheader-img" src="~img/icons/morillas-svg-icons/primary/stethoscope-unplugged.svg"  v-if="!$store.state.video.useStethoscope"/>
        <img class="center-block subheader-img" src="~img/icons/morillas-svg-icons/primary/stethoscope-plugged.svg"  v-if="$store.state.video.useStethoscope" />
      </div>
      <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
        <div v-if="$store.state.video.useStethoscope">
          {{$t('stethoscope1')}}
          <br /><br />
          {{$t('stethoscope3')}}
          <br /><br />
          {{$t('stethoscope4')}}
          <br><br>
          {{ $t('stethoscope-refresh') }}
          <br>
          <img src="/static-appopensalud/img/icons/refresh-icon-blue-fill.svg" v-if="!$uiHelpers.isMobile" class="mt-4 rounded-btn" :title="$t('refresh-label')" style="display: block; margin: auto; background-color: rgb(78, 140, 255)"/>
        </div>
        <div v-if="!$store.state.video.useStethoscope">
          {{$t('stethoscope5')}}
          <br /><br />
          {{$t('stethoscope6')}}
          <br /><br />
          {{$t('stethoscope7')}}
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button variant="primary" class="float-right ml-2" @click="switchStethoscope">
          {{$t('continue')}}
        </b-button>
        <base-button red class="float-right"  @click="close">
          {{$t('cancel')}}
        </base-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import _ from 'lodash'
  import { BModal, BButton, BIconArrowClockwise } from 'bootstrap-vue'
  import { SUPPORTED_SOUNDCARDS } from '@/constants/supportedSoundcards'

  export default {
    components: {
      BModal,
      BButton,
      BIconArrowClockwise
    },
    data () {
      return {
        showModal: false
      }
    },
    methods: {
      switchStethoscope () {
        let deviceIndex = 0
        navigator.mediaDevices.enumerateDevices().then((devices) => {
          let audioDevices = _.uniqBy(devices.filter(d => d.kind === 'audioinput'), 'groupId')
          let currentAudioSource = _.find(audioDevices, (d) => d.label === this.$store.state.video.opentok.publisher.getAudioSource().label)
          let loopDevIndex = (parseInt(audioDevices.indexOf(currentAudioSource)) + 1) % audioDevices.length
          // Current audio source groupId is the same as the groupId in current device in iteration and next device in loop groupId is different from current using device groupId
          if (this.$store.state.video.useStethoscope) {
            const supportedDevices = audioDevices.filter(d => SUPPORTED_SOUNDCARDS.some(ss => d.label.includes(ss)))
            deviceIndex = supportedDevices.length > 0 ? audioDevices.indexOf(supportedDevices[0]) : loopDevIndex
          } else {
            deviceIndex = loopDevIndex
          }
          var device = audioDevices[deviceIndex]
          this.$store.state.video.opentok.publisher.setAudioSource(device.deviceId)
          this.$store.commit('video/setSelectedAudioSource', device)
          this.showModal = false
        })
      },
      close () {
        this.showModal = false
        this.$store.commit('video/toggleStethoscope')
      }
    }
  }
</script>

<style scoped>
  .btn-danger {
    color: white;
  }

  .center-block {
    display: block;
    margin-left: auto;
    margin-right: auto
  }

  .subheader-img {
    width: 150px; 
    margin: 0px auto 35px auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/video-launcher/StethoscopeModal.vue